import { render, staticRenderFns } from "./TopSwitch.vue?vue&type=template&id=78fe90e2&scoped=true"
import script from "./TopSwitch.vue?vue&type=script&lang=js"
export * from "./TopSwitch.vue?vue&type=script&lang=js"
import style0 from "./TopSwitch.vue?vue&type=style&index=0&id=78fe90e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe90e2",
  null
  
)

export default component.exports